// Centralised lookup of category → hero image.
//
// 10 categories use cropped/illustrated artwork served from the backend at
// /api/uploads/categories/{slug}.jpg. The rest fall back to themed stock
// photography. Used by:
//   - LandingPage  ("Explore Categories" grid + Featured-card fallback)
//   - BusinessProfilePage  (hero banner fallback when business.image_url is empty)
//   - DirectoryPage / CategoryLandingPage  (already use BusinessLogo for the
//     primary thumbnail; this map is the safety net)

const ASSET_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/uploads/categories`;

export const CATEGORY_IMAGES = {
  "Food & Beverage": `${ASSET_BASE}/food-beverage.jpg`,
  "Fashion & Apparel": `${ASSET_BASE}/fashion-apparel.jpg`,
  "Beauty & Wellness": `${ASSET_BASE}/beauty-wellness.jpg`,
  "Home & Living": `${ASSET_BASE}/home-living.jpg`,
  "Art & Crafts": `${ASSET_BASE}/art-crafts.jpg`,
  "Media and Entertainment": `${ASSET_BASE}/books-media.jpg`,
  "Technology": `${ASSET_BASE}/technology.jpg`,
  "Professional Services": `${ASSET_BASE}/professional-services.jpg`,
  "Health & Fitness": `${ASSET_BASE}/health-fitness.jpg`,
  "Kids & Family": `${ASSET_BASE}/kids-family.jpg`,
  // Stock photo fallbacks for categories without a custom tile
  "Real Estate": `${ASSET_BASE}/real-estate.jpg`,
  "Medical Services": `${ASSET_BASE}/medical.jpg`,
  "Travel": `${ASSET_BASE}/travel.jpg`,
  "Influencer/Content Creator": `${ASSET_BASE}/influencer.jpg`,
  "Podcaster": `${ASSET_BASE}/podcaster.jpg`,
  "Streamer": `${ASSET_BASE}/streamer.jpg`,
  "Transportation": `${ASSET_BASE}/transportation.jpg`,
  // Trades & Home Services — Unsplash fallbacks until custom tiles are uploaded
  "HVAC": "https://images.unsplash.com/photo-1631545308456-c30b8ed398a6?w=800&q=80",
  "Plumbing": "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800&q=80",
  "Electrical": "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=800&q=80",
  "Masonry": "https://images.unsplash.com/photo-1590247813693-5541d1c609fd?w=800&q=80",
  "Construction": "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80",
  "Roofing": "https://images.unsplash.com/photo-1632759145355-8b8f96d9f2c1?w=800&q=80",
  "Landscaping": "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=800&q=80",
  "Cleaning Services": "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80",
  "Automotive": "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800&q=80",
  "Painting": "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&q=80",
  "Carpentry": "https://images.unsplash.com/photo-1601058268499-e52658b8bb88?w=800&q=80",
  "Handyman": "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=800&q=80",
  "Other": `${ASSET_BASE}/other.jpg`,
};

export const DEFAULT_HERO_FALLBACK = CATEGORY_IMAGES["Other"];

export function heroImageForCategory(category) {
  return CATEGORY_IMAGES[category] || DEFAULT_HERO_FALLBACK;
}
